// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__m4ZXW","bigColWidth":"Table_bigColWidth__2-w25","biggerColWidth":"Table_biggerColWidth__2_JmO","row":"Table_row__30dAJ","col":"Table_col__3S9Qt"};